import { Chip, styled } from '@mui/material';

export const PillContainer = styled(Chip)(({ theme, hide }) => ({
  display: hide && 'none',
  width: '58px',
  height: '20px',
  backgroundColor: theme.palette.colors.label,
  borderRadius: '10px',
  gap: '3px',
  cursor: 'pointer',

  ':hover': {
    backgroundColor: theme.palette.colors.mainFocused,
  },

  '& .MuiChip-label': {
    fontSize: '10px',
    fontWeight: 'bold',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: theme.palette.colors.onMenuBackground,
    padding: 0,
  },

  '& .MuiChip-icon': {
    fontSize: '11px',
    color: theme.palette.colors.onMenuBackground,
    marginLeft: 0,
    marginRight: 0,
  },
}));
